module.exports = __webpack_public_path__ + "assets/images/53fb62c59cc687685bef5874f406ee3e.png";